
import { supabase } from "@/integrations/supabase/client";

export async function deleteUser(targetUserId: string, adminPassword: string, notes?: string) {
  try {
    const { data, error } = await supabase.functions.invoke("delete-user", {
      body: {
        targetUserId,
        password: adminPassword,
        notes
      }
    });

    if (error) {
      throw new Error(error.message || "Failed to delete user");
    }

    if (!data.success) {
      throw new Error(data.error || "Failed to delete user");
    }

    return data;
  } catch (error: any) {
    console.error("Error in deleteUser service:", error);
    throw error;
  }
}
